import { render } from "./EssayView.vue?vue&type=template&id=94ae35ac"
import script from "./EssayView.vue?vue&type=script&lang=js"
export * from "./EssayView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__